// The campaign's opening cash on hand, a column on the finance settings row. Each write checks
// and bumps that row's token, so each shows on click in the settings read and lands the returned
// result and token there; a stale write restores the read and refetches it.

import { getApiClient } from '@signalvote/api-client';
import type { OpeningBalanceClearRequest, OpeningBalanceRequest, OpeningBalanceResult } from '@signalvote/shared';
import { defineWrite, edit } from '@/lib/data';
import { financeSettingsRead, useRefreshFinanceAfter } from './useFinanceSettings';

type Balance = Pick<OpeningBalanceResult, 'openingBalance' | 'openingBalanceDate'>;

function show(balance: Balance) {
  return [edit(financeSettingsRead, undefined, (settings) => settings && { ...settings, ...balance })];
}

function land(result: OpeningBalanceResult) {
  return [edit(financeSettingsRead, undefined, (settings) => settings && { ...settings, ...result })];
}

const recordOpeningBalance = defineWrite({
  send: (body: OpeningBalanceRequest) => getApiClient().openingBalance.recordOpeningBalance(body),
  patch: ({ openingBalance, openingBalanceDate }) => show({ openingBalance, openingBalanceDate }),
  land,
});

const updateOpeningBalance = defineWrite({
  send: (body: OpeningBalanceRequest) => getApiClient().openingBalance.updateOpeningBalance(body),
  patch: ({ openingBalance, openingBalanceDate }) => show({ openingBalance, openingBalanceDate }),
  land,
});

const clearOpeningBalance = defineWrite({
  send: (body: OpeningBalanceClearRequest) => getApiClient().openingBalance.clearOpeningBalance(body),
  patch: () => show({ openingBalance: null, openingBalanceDate: null }),
  land,
});

export function useRecordOpeningBalance() {
  return useRefreshFinanceAfter(recordOpeningBalance());
}

export function useUpdateOpeningBalance() {
  return useRefreshFinanceAfter(updateOpeningBalance());
}

export function useClearOpeningBalance() {
  return useRefreshFinanceAfter(clearOpeningBalance());
}
